// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ThreeDotsLoader_loaderContainer__VEr32","dot":"ThreeDotsLoader_dot__U5oGk","dotAnimation":"ThreeDotsLoader_dotAnimation__x52pC"};